import $ from 'jquery';
import LangValue from '../Lang/_LangValue';
import Page from '../Page/_State';

class Lang {
  constructor(target) {
    this.langType = new LangValue();
    this.className = 'lang--fc';
    this.classNameLang = ['--jp', '--en', '--ch', '--ko'];
    this.target = $(target);
    this.li = this.target.find('li');
    this.liAll = $('li[data-lang-type]');
    this.langChangeImgAll = $('.lang-change-img');
    this.langChangeTxtAll = $('.lang-change-txt');
    this._setEvent();
    this._setFc();
  }

  _setEvent() {
    this.li.click(
      function (e) {
        $('a[href="#page-top"]').trigger('click');
        let type = $(e.currentTarget).data('lang-type');
        this.langType.setLang(type);
        this._setFc();
        this._langChange();
        return false;
      }.bind(this),
    );
  }

  _setFc() {
    let parent = this;
    let type = this.langType.getLang();
    this.liAll.removeClass(this.className);
    this.liAll.each(function () {
      if ($(this).data('lang-type') == type) $(this).addClass(parent.className);
    });
    $('.lang-debug').html('選択言語：' + type);
  }

  _langChange() {
    let type = this.langType.getLang();
    let classNameLangAry = this.classNameLang;
    // 画像
    this.langChangeImgAll.each(function () {
      let urlOrg = $(this).attr('src');

      for (const value of classNameLangAry) $(this).removeClass(value);
      $(this).addClass('--' + type);

      if (urlOrg) {
        let urlChange = urlOrg.replace(/\/language\/(jp|en|ch|ko)\//g, '/language/' + type + '/');
        $(this).attr('src', urlChange);
      }
    });

    // テキスト
    this.langChangeTxtAll.each(function () {
      for (const value of classNameLangAry) $(this).removeClass(value);
      $(this).addClass('--' + type);
      $(this).find('.jp, .en, .ch, .ko').hide();
      $(this).find('.' + type).show();
    });
  }
}

(() => {
  const targets = document.querySelectorAll('.pc-bg-lang, .lang');
  if (!targets.length) return;
  targets.forEach((item) => {
    new Lang(item);
  });
})();
